<template>
  <div>
    <form class="mt-3" @submit.prevent="submit">
      <div class="row">
        <div class="col-md-12">
          <validated-input v-if="isEdit" v-model="currentItem.abbreviation" :disabled="true" />
          <autocomplete-input
            v-else
            placeholder="Select State..."
            :optionsV="availableStates"
            label="name"
            track-by="abbreviation"
            :outValKey="true"
            :multiple="false"
            :validate="{ required: true }"
            v-model="currentItem.abbreviation"
          />

          <validated-input
            class="mt-3"
            v-model="currentItem.fixedTaxRate"
            label="Fixed Tax Rate"
            :validate="{ minVal: 0, maxVal: 0.99, decimal: true }"
          />
        </div>
      </div>
      <div class="mt-3">
        <button class="btn btn-primary" type="submit" :disabled="errors.any() || loading">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'NexusStateForm',
  props: {
    currentItem: {
      type: Object,
      required: true
    },
    isEdit: Boolean,
    availableStates: Array,
    loading: Boolean
  },
  data() {
    return {
      columns: ['abbreviation', 'fixedTaxRate', 'actions']
    };
  },
  methods: {
    async submit() {
      await this.$validator.validateAll();
      if (this.errors.any()) return;
      this.$emit('submit', { ...this.currentItem });
    }
  }
};
</script>
